import { PaymentLogicType } from "@customTypes/PaymentLogicType";

export const DefaultTutorPaymentLogic: PaymentLogicType = {
  paymentLogicId: 0,
  days: null,
};
